/**
 * Error Handler Initializer Component
 *
 * This component initializes the global error handler with the required contexts.
 * It should be placed inside the AuthProvider and ToastProvider to access their contexts.
 */

import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import { errorHandler } from "../../utils/errorHandler";

const ErrorHandlerInitializer = () => {
  const authContext = useAuth();
  const toastContext = useToast();

  useEffect(() => {
    // Initialize the error handler with the required contexts
    errorHandler.initialize(toastContext, authContext);
  }, [authContext, toastContext]);

  // This component doesn't render anything
  return null;
};

export default ErrorHandlerInitializer;
